import { render, staticRenderFns } from "./ContentTemplate.vue?vue&type=template&id=5f5e2467&scoped=true&"
import script from "./ContentTemplate.vue?vue&type=script&lang=ts&"
export * from "./ContentTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ContentTemplate.vue?vue&type=style&index=0&id=5f5e2467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e2467",
  null
  
)

component.options.__file = "ContentTemplate.vue"
export default component.exports